import { forwardRef } from 'react';
import { Field, WrappedFieldProps } from 'redux-form';
import { TextInputProps } from '@optimus-web/core';
import { withAutoFocusingFirstFocusableElement } from '../../hoc/withAutoFocus';
import { getError } from '../../utils';
import { InputField as InputFieldBase } from '../Input';

type InputFieldRendererProps = WrappedFieldProps & TextInputProps;

export const InputFieldRenderer = ({ input, meta, ...other }: InputFieldRendererProps) => (
    <InputFieldBase error={getError(meta)} {...other} {...input} />
);

export const InputField = forwardRef<HTMLElement, TextInputProps & { bottomCaption?: TextInputProps['helper'] }>(
    (props, ref) => (
        // @ts-expect-error $TSFixMeError: No overload matches this call.
        <Field component={InputFieldRenderer} ref={ref} {...props} />
    )
);

export type InputFieldProps = React.ComponentPropsWithRef<typeof InputField> & React.ComponentProps<typeof Field>;

export const AutoFocusedInputField: React.ComponentType<InputFieldProps & { selectOnFocus?: boolean }> =
    withAutoFocusingFirstFocusableElement()(InputField) as $TSFixMe;
